// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__204sX","title":"Header_title__MVnZK","left":"Header_left__1iAfB","clinicName":"Header_clinicName__3TaCg"};